import { colors } from 'app-v2/design-systems/theme'
import { ButtonMedium, media } from 'app/assets/styles'
import ExecutionEnvironment from 'exenv'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import onClickOutside from 'react-onclickoutside'
import { colors as oldColors } from 'shared/assets/styles'
import type { FilterShortDTO } from 'shared/types'
import styled from 'styled-components'
import { Filter } from './Filter'

const { grey, shadowBox } = oldColors

type Props = {
    filters: FilterShortDTO[],
    selectedFilters: string[],
    handleReset: () => void,
    handleApply: () => void,
    handleUpdate: (filter: FilterShortDTO) => void,
    handleClose: () => void,
    clickOutside?: boolean
}

class FiltersComponent extends Component<Props> {
    // Function To Handle ClickOutside Dropdown herited from react-onclickoutside
    handleClickOutside(e) {
        const { clickOutside, handleClose } = this.props
        if (clickOutside) {
            setTimeout(() => handleClose(), 150)
        }
    }

    apply = () => {
        const { handleApply, handleClose } = this.props
        handleApply()
        handleClose()
        if (ExecutionEnvironment.canUseDOM) {
            window.scrollTo(0, 0)
        }
    }

    render() {
        const {
            handleReset,
            handleUpdate,
            filters,
            selectedFilters
        } = this.props

        return (
            <FiltersContainer>
                <Dropdown>
                    <FiltersList>
                        {filters.map((filter, index) => (
                            <Filter
                                updateFilters={() => handleUpdate(filter)}
                                checked={
                                    selectedFilters.indexOf(filter.code) > -1
                                }
                                {...filter}
                                key={index}
                            />
                        ))}
                    </FiltersList>
                    <FiltersButtons>
                        <StyledButtonMedium
                            border={grey}
                            color={grey}
                            background="transparent"
                            onClick={handleReset}>
                            <FormattedMessage id="filters.button.reset" />
                        </StyledButtonMedium>
                        <StyledButtonMedium
                            onClick={this.apply}
                            color={colors.lightMayo}
                            background={colors.crunchyGreen}
                            border={colors.crunchyGreen}>
                            <FormattedMessage id="filters.button.apply" />
                        </StyledButtonMedium>
                    </FiltersButtons>
                </Dropdown>
            </FiltersContainer>
        )
    }
}

const FiltersContainer = styled.div`
    position: relative;
    z-index: 10000;
    ${media.medium`
        min-height: unset;
    `};
`

const StyledButtonMedium = styled(ButtonMedium)`
    width: 48%;
`

const Dropdown = styled.div`
    ${media.medium`
        position: absolute;
        right: 0;
        margin-top: 20px;
        padding: 20px;
        z-index: 10;
        background-color: white;
        min-width: 400px;
        border-radius: 4px;
        box-shadow: 0 4px 16px 4px ${shadowBox};
    `};
`

const FiltersList = styled.ul`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
    overflow-y: scroll;
    max-height: calc(100vh - 180px);
    ${media.medium`
        min-height: 300px;
        max-height: calc(100vh - 550px);
    `}
    border-bottom: 1px solid ${colors.lightGrey};
`

const FiltersButtons = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
`

export const Filters = onClickOutside(FiltersComponent)
